import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core';
import { MerchantFilter, MerchantService } from '../merchants/merchant-master/merchant.service';
import * as htmlToImage from 'html-to-image';
import { from } from 'rxjs';
import { AlertService } from 'src/app/_services/alert.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgSelectComponent } from '@ng-select/ng-select';
import { escape } from 'querystring';

@Component({
  selector: 'app-qr-code-generation',
  templateUrl: './qr-code-generation.component.html',
  styleUrls: ['./qr-code-generation.component.scss']
})
export class QrCodeGenerationComponent implements OnInit, OnDestroy {
   @ViewChild('qrDropdown') private qrDropdown: NgSelectComponent;
  merchantDropdown : any[];
  merchantName : any;
  merchantIdentifier : any;
  mobileNumber : any;
  merchant : any;
  enableQR : boolean = false;
  qrCode : any;
  enableQRDropdown : boolean = false;
  isDownloading : boolean = false;

  currentLang: string = 'en';
  private langObserver: MutationObserver | null = null;
  private checkInterval: any = null;

  constructor(
    private merchantService : MerchantService,
    private alertService: AlertService,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.merchantDropdown = [];
    this.merchantList();
    this.initLanguageDetection();
  }

  ngOnDestroy(): void {
    if (this.langObserver) {
      this.langObserver.disconnect();
    }
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }

  initLanguageDetection() {
    this.currentLang = this.getCurrentLang();

    // Periodic check as fallback
    this.ngZone.runOutsideAngular(() => {
      this.checkInterval = setInterval(() => {
        if (this.isDownloading) return;
        const detected = this.getCurrentLang();
        if (detected !== this.currentLang) {
          this.ngZone.run(() => {
            this.currentLang = detected;
            this.cdr.detectChanges();
          });
        }
      }, 500);
    });

    // MutationObserver on html element to react immediately
    if (typeof MutationObserver !== 'undefined') {
      this.langObserver = new MutationObserver(() => {
        if (this.isDownloading) return;
        const detected = this.getCurrentLang();
        if (detected !== this.currentLang) {
          this.ngZone.run(() => {
            this.currentLang = detected;
            this.cdr.detectChanges();
          });
        }
      });

      this.langObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['lang', 'class']
      });
    }
  }

  getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
  }

  getCurrentLang(): string {
    if (typeof document === 'undefined') return 'en';

    // 1. Check googtrans cookie
    const cookieValue = this.getCookie('googtrans');
    if (cookieValue) {
      const parts = cookieValue.split('/');
      const lang = parts[parts.length - 1]?.toLowerCase();
      if (lang === 'fr' || lang === 'ar' || lang === 'en') {
        return lang;
      }
    }

    // 2. Check html lang attribute
    const htmlLang = document.documentElement.getAttribute('lang')?.toLowerCase();
    if (htmlLang) {
      if (htmlLang.startsWith('fr')) return 'fr';
      if (htmlLang.startsWith('ar')) return 'ar';
      if (htmlLang.startsWith('en')) return 'en';
    }

    // 3. Check select.goog-te-combo value
    const selectElem = document.querySelector('select.goog-te-combo') as HTMLSelectElement | null;
    if (selectElem && selectElem.value) {
      const selectLang = selectElem.value.toLowerCase();
      if (selectLang.startsWith('fr')) return 'fr';
      if (selectLang.startsWith('ar')) return 'ar';
      if (selectLang.startsWith('en')) return 'en';
    }

    return 'en';
  }

  get approvedByText(): string {
    return this.getTranslation('approvedBy');
  }

  get scanPayText(): string {
    return this.getTranslation('scanPay');
  }

  get merchantIdText(): string {
    return this.getTranslation('merchantId');
  }

  get walletsTitleText(): string {
    return this.getTranslation('walletsTitle');
  }

  getTranslation(key: string): string {
    const lang = this.currentLang || 'en';
    const dict: { [key: string]: { [key: string]: string } } = {
      en: {
        approvedBy: "Agréé par Bank Al-Maghrib",
        scanPay: "SCAN & PAY",
        merchantId: "ID Commerçant",
        walletsTitle: "ICI, NOUS ACCEPTONS LES PAIEMENTS VIA +18 WALLETS"
      },
      fr: {
        approvedBy: "Agréé par Bank Al-Maghrib",
        scanPay: "SCAN & PAY",
        merchantId: "ID Commerçant",
        walletsTitle: "ICI, NOUS ACCEPTONS LES PAIEMENTS VIA +18 WALLETS"
      },
      ar: {
        approvedBy: "معتمد من طرف بنك المغرب",
        scanPay: "سكاني وخلّص",
        merchantId: "معرف التاجر",
        walletsTitle: "هنا، يمكنك الأداء بأكثر من 18 محفظة رقمية"
      }
    };
    return dict[lang]?.[key] || dict['en'][key];
  }

  formatPhoneNumber(phone: any): string {
    if (!phone) return '';

    let cleaned = String(phone).replace(/\D/g, '');

    if (cleaned.startsWith('212') && cleaned.length === 12) {
      cleaned = cleaned.substring(3);
    } else if (cleaned.startsWith('00212') && cleaned.length === 14) {
      cleaned = cleaned.substring(5);
    }

    if (!cleaned.startsWith('0') && cleaned.length === 9) {
      cleaned = '0' + cleaned;
    }

    const matches = cleaned.match(/.{1,2}/g);
    return matches ? matches.join(' ') : cleaned;
  }

  merchantList() {
    const filter: MerchantFilter = {}
    filter.startDate = "";
    filter.endDate = "";
    this.merchantService.getMerchantList("","","","","","","",filter,"ALL",0).subscribe((response)=>{
      console.log(response);
      this.merchantDropdown = response.content;
    })
  }

  merchantChange(event:any){
    console.log(event);
    if(event != undefined && event != ""){
      this.enableQR = true;
      this.merchantName = event.fullName;
      this.mobileNumber = this.formatPhoneNumber(event.mobileNumber);
      this.merchantIdentifier = this.mobileNumber;
      const payload = {
          "referenceId": event.userId,
          "receiver": event.mobileNumber,
          "qrType": "STATIC",
          "qrCategory": "1",
          "merchantName": event.mobileNumber,
          "merchantCity": "Casablanca",
          "country": "MA",
          "mccCode": "5411",
          "product": "QR_GENERATION"
      }
      this.merchantService.getMerchantStaticQR(payload).subscribe((response:any)=>{
        const qrCodeImage = response?.response?.data?.qrCodeImage;
        if (qrCodeImage) {
          const dataUrl = `data:image/png;base64,${qrCodeImage}`;
          this.qrCode = this.domSanitizer.bypassSecurityTrustUrl(dataUrl);
        } else {
          this.alertService.toastWarringMessageAlertWithMessage("Error while generating the QR Code");
        }
      })
    }else{
      this.merchantName="";
      this.merchantIdentifier = "";
      this.mobileNumber = "";
      this.enableQR = false;
    }
  }

//   downloadQR(type:string,size:string) {
//     const docElem = document.getElementById(type) as HTMLElement | null;
//     if (!docElem) {
//         this.alertService.toastWarringMessageAlertWithMessage("Error while downloading the QR Code");
//         return;
//     }
//     document.fonts.ready.then(() => {
//         setTimeout(() => {
//             htmlToImage.toPng(docElem
//             ).then((canvas) => {
//                 const a = document.createElement('a');
//                 a.download = this.merchantName + `_STATIC_QR_`+size+`.png`;
//                 a.href = canvas;
//                 a.click();
//                 console.log("Image downloaded successfully");
//             }).catch((error) => {
//                 console.error("Error capturing image:", error);
//             });
//         }, 1200);
//     });
//     this.enableQRDropdown = false;
//     this.qrDropdown.handleClearClick();
// }

  // Renders the QR card for a given language at A5 (300 DPI) resolution and returns its data URL.
  // Shared by download and print so both outputs stay pixel-identical.
  async generateQRImage(type: string, lang: string, format: 'png' | 'svg'): Promise<string> {
    // 1. Temporarily switch language
    this.currentLang = lang;
    this.cdr.detectChanges();

    // 2. Wait 300ms for Angular to complete binding update and let the browser repaint
    await new Promise(resolve => setTimeout(resolve, 300));

    const docElem = document.getElementById(type) as HTMLElement | null;
    if (!docElem) {
      throw new Error("Element not found");
    }

    // A5 Paper Size at 300 DPI is exactly 1748 x 2480 pixels
    const targetWidth = 1748;
    const targetHeight = 2480;

    const originalWidth = docElem.offsetWidth;
    const originalHeight = docElem.offsetHeight;

    if (format === 'svg') {
      return htmlToImage.toSvg(docElem, {
        width: targetWidth,
        height: targetHeight,
        style: {
          transform: `scale(${targetWidth / originalWidth}, ${targetHeight / originalHeight})`,
          transformOrigin: 'top left',
          width: originalWidth + 'px',
          height: originalHeight + 'px',
        }
      });
    }

    // Use high-quality pixelRatio logic for PNG
    const pixelRatio = targetWidth / originalWidth;
    return htmlToImage.toPng(docElem, {
      quality: 1,
      pixelRatio: pixelRatio,
      width: originalWidth,
      height: originalHeight,
      canvasWidth: originalWidth,
      canvasHeight: targetHeight / pixelRatio,
      cacheBust: true,
    });
  }

  async captureAndDownload(type: string, lang: string, format: 'png' | 'svg'): Promise<void> {
    const dataUrl = await this.generateQRImage(type, lang, format);

    const a = document.createElement('a');
    a.download = `${this.merchantName}_STATIC_QR_A5_${lang.toUpperCase()}.${format}`;
    a.href = dataUrl;
    a.click();
  }

  async downloadQR(type: string, format: 'png' | 'svg') {
    const docElem = document.getElementById(type) as HTMLElement | null;
    if (!docElem) {
      this.alertService.toastWarringMessageAlertWithMessage("Error while downloading the QR Code");
      return;
    }

    const originalLang = this.currentLang;
    this.isDownloading = true; // Set download flag to bypass background language detection

    // Wait for fonts to be ready
    await document.fonts.ready;

    try {
      const formatUpper = format.toUpperCase();
      this.alertService.toastSuccessMessageAlertWithMessage(`Téléchargement du QR Code en Français (${formatUpper})...`);
      await this.captureAndDownload(type, 'fr', format);

      // Wait 1.2s before the second capture so the browser and UI handle the first download nicely
      await new Promise(resolve => setTimeout(resolve, 1200));

      this.alertService.toastSuccessMessageAlertWithMessage(`تحميل رمز الاستجابة السريعة باللغة العربية (${formatUpper})...`);
      await this.captureAndDownload(type, 'ar', format);

      this.alertService.toastSuccessMessageAlertWithMessage(`Téléchargement réussi / تم التحميل بنجاح (${formatUpper})`);
    } catch (error) {
      console.error(`Error during sequential QR ${format} download:`, error);
      this.alertService.toastWarringMessageAlertWithMessage("Erreur lors du téléchargement");
    } finally {
      // Restore user's original language selection
      this.currentLang = originalLang;
      this.isDownloading = false; // Reset download flag
      this.cdr.detectChanges();
    }
  }

  // Sends both QR cards (FR + AR) directly to the browser's print dialog on a single
  // borderless A4 landscape sheet (2 x A5 halves), skipping any manual download step.
  async printDualQRCode(type = 'staticQrCodeCard'): Promise<void> {
    if (!document.getElementById(type)) {
      this.alertService.toastWarringMessageAlertWithMessage("Error while preparing the QR Code for printing");
      return;
    }

    const originalLang = this.currentLang;
    this.isDownloading = true; // Bypass background language detection while we swap languages

    await document.fonts.ready;

    try {
      // Same A5 (300 DPI) generation path as the PNG download, so print output matches downloads exactly
      const frDataUrl = await this.generateQRImage(type, 'fr', 'png');
      const arDataUrl = await this.generateQRImage(type, 'ar', 'png');

      const printWindow = window.open('', '_blank', 'width=1200,height=850');
      if (!printWindow) {
        this.alertService.toastWarringMessageAlertWithMessage("Veuillez autoriser les pop-ups pour imprimer le QR Code");
        return;
      }

      printWindow.document.open();
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <title>${this.merchantName || 'QR Code'}</title>
          <style>
            @page { size: A4 landscape; margin: 0; }
            * { box-sizing: border-box; }
            html, body {
              margin: 0;
              padding: 0;
              width: 297mm;
              height: 210mm;
              overflow: hidden;
            }
            .print-container {
              display: flex;
              width: 297mm;
              height: 210mm;
            }
            .print-half {
              width: 149.5mm;
              height: 210mm;
              overflow: hidden;
              line-height: 0;
              flex-shrink: 0;
            }
            /* 2mm overlap at the seam to hide any sub-mm gap from printer scaling/margins */
            .print-half + .print-half {
              margin-left: -2mm;
            }
            .print-half img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: fill;
            }
          </style>
        </head>
        <body>
          <div class="print-container">
            <div class="print-half"><img src="${frDataUrl}" alt="QR Code FR"></div>
            <div class="print-half"><img src="${arDataUrl}" alt="QR Code AR"></div>
          </div>
        </body>
        </html>
      `);
      printWindow.document.close();

      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 500);
      };
    } catch (error) {
      console.error("Error preparing QR code for print:", error);
      this.alertService.toastWarringMessageAlertWithMessage("Erreur lors de la préparation de l'impression");
    } finally {
      this.currentLang = originalLang;
      this.isDownloading = false;
      this.cdr.detectChanges();
    }
  }

  // Prints both QR cards (FR + AR) as vector SVG, each on its own A4 portrait sheet with
  // the card kept at true A5 size and centered (no stretching/full-bleed), so quality stays crisp.
  async printQRCodeA5InA4(type = 'staticQrCodeCard'): Promise<void> {
    if (!document.getElementById(type)) {
      this.alertService.toastWarringMessageAlertWithMessage("Error while preparing the QR Code for printing");
      return;
    }

    const originalLang = this.currentLang;
    this.isDownloading = true; // Bypass background language detection while we swap languages

    await document.fonts.ready;

    try {
      const frSvgUrl = await this.generateQRImage(type, 'fr', 'svg');
      const arSvgUrl = await this.generateQRImage(type, 'ar', 'svg');

      const printWindow = window.open('', '_blank', 'width=1000,height=1400');
      if (!printWindow) {
        this.alertService.toastWarringMessageAlertWithMessage("Veuillez autoriser les pop-ups pour imprimer le QR Code");
        return;
      }

      printWindow.document.open();
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <title>${this.merchantName || 'QR Code'}</title>
          <style>
            @page { size: A4 portrait; margin: 0; }
            * { box-sizing: border-box; }
            html, body { margin: 0; padding: 0; }
            .a4-page {
              width: 210mm;
              height: 297mm;
              display: flex;
              align-items: center;
              justify-content: center;
              page-break-after: always;
            }
            .a4-page:last-child { page-break-after: auto; }
            .a5-frame {
              width: 148.5mm;
              height: 210mm;
              overflow: hidden;
              line-height: 0;
            }
            .a5-frame img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          </style>
        </head>
        <body>
          <div class="a4-page"><div class="a5-frame"><img src="${frSvgUrl}" alt="QR Code FR"></div></div>
          <div class="a4-page"><div class="a5-frame"><img src="${arSvgUrl}" alt="QR Code AR"></div></div>
        </body>
        </html>
      `);
      printWindow.document.close();

      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 500);
      };
    } catch (error) {
      console.error("Error preparing SVG QR code for print:", error);
      this.alertService.toastWarringMessageAlertWithMessage("Erreur lors de la préparation de l'impression");
    } finally {
      this.currentLang = originalLang;
      this.isDownloading = false;
      this.cdr.detectChanges();
    }
  }

}
